// extracted by mini-css-extract-plugin
export default {"hsSingleQuestion":"QuestionItemContent_hsSingleQuestion__gg84Z","hsSingleQuestionTitle":"QuestionItemContent_hsSingleQuestionTitle__P-vQv"};